export default __webpack_public_path__ + "images/Kebab.c23826.jpg";